export const StyleMainStack = {
    marginTop: "20px",
    backgroundColor: "white",
    padding: "10px 14px",
    borderRadius: "10px",
  }

 export const SublistDesStyle ={
    color: "#190e62",
    fontWeight: "500",
     fontSize: "18px",
    fontweight: "600"
  }
  
 export  const SublistIdStyle ={
    width: "25px",
    height: "25px",
    background: "red",
    borderRadius: "50%",
    color: "white",
    display :"flex",
    alignItems: "center",
    justifyContent: "center"
  }
  export const BoxSubTimeAndDescStyle= {
    display: "flex",
    alignItems: "Center",
    gap: "10px",
  }
  

  export const StyleTitleCourses ={
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  }

  export const StyleListItemButton ={
    padding: "13px 3px",
    backgroundColor: "#c6ecec",
    borderRadius: "10px",
    "&:hover": {
      backgroundColor: "white",
    },
  }

  export const StyleListItemButtonCollaps ={
    backgroundColor: "white",
     borderRadius: "10px",
       padding: "15px 10px",
     "&:hover": {
       backgroundColor: "white",
  },
  }